<template>
  <svg
    id="Layer_1"
    class="va-icon-vuestic"
    :height="height"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 364 50"
    style="enable-background: new 0 0 364 50"
    xml:space="preserve"
  >
    <g id="XMLID_3172_">
      <g id="XMLID_3203_">
        <g id="XMLID_3241_">
          <path
            id="XMLID_3242_"
            d="M24.2,48.9c0-0.6,0.5-1.1,1.1-1.1l0,0l9.8,0c1.2,0,2.2-0.6,2.7-1.7l0,0l0-0.1l12-16.6
				c0.7-1.3,1.1-2.8,1.1-4.5l0,0c0-1.6-0.4-3.1-1.1-4.5l0,0l-12-16.6l0-0.1c-0.6-1-1.6-1.7-2.7-1.7l0,0H8.6C6,2.2,3.9,4.4,3.9,7.1
				l0,0v35.8c0,2.7,2.1,4.9,4.7,4.9l0,0h9.2l13.1-20.6l0.6,0c2.1,0.1,4.6,0.2,5.8,0.2l0,0c1.5,0,3.1-0.2,4.4-0.5l0,0
				c1.3-0.3,2.4-0.8,2.9-1.2l0,0c0.3-0.3,0.4-0.5,0.4-0.5l0,0c0-0.1,0-0.2-0.4-0.5l0,0c-0.3-0.3-0.9-0.6-1.6-0.9l0,0
				c-1.5-0.5-3.6-0.9-5.6-0.9l0,0c-1.2,0-3.7,0.1-5.8,0.2l0,0l-0.6,0L21.6,8.7h-2.2L25,23.3l-1.6,0.1c-0.9,0-2.5,0.1-4.1,0.2l0,0
				c-1.5,0.1-3,0.2-3.6,0.3l0,0l-0.6,0.1l-3.2-3.3H9.8l1.6,4.3v0.2v0.4l-1.6,4.3h2.1l3.2-3.3l0.6,0.1c0.6,0.1,2.1,0.2,3.6,0.3l0,0
				c1.5,0.1,3.1,0.1,4.1,0.2l0,0v0c0.6,0,1.1,0.5,1.1,1.1l0,0c0,0.6-0.5,1.1-1.1,1.1l0,0c-0.9,0-2.5-0.1-4.1-0.2l0,0
				c-1.2-0.1-2.4-0.1-3.2-0.2l0,0l-2.7,2.7l-0.4,0.4h-0.5l-0.1,0l-3.7,0H6.6l0.7-1.8l1.9-4.9l-1.9-4.9l-0.7-1.8h1.6h0.4h3.7h0.6
				l0.3,0.3l0.1,0.1l2.7,2.7c0.8-0.1,2-0.1,3.2-0.2l0,0c0.9,0,1.8-0.1,2.5-0.1l0,0l-5-12.9l-0.6-1.8h1.6h0.3H22h0.8L23.1,7l0.1,0.1
				l8.9,13.7c2-0.1,4.1-0.1,5.3-0.1l0,0c1.7,0,3.4,0.2,4.9,0.6l0,0c1.5,0.4,2.8,0.9,3.8,1.7l0,0c0.6,0.5,1.1,1.3,1.1,2.2l0,0
				c0,0.9-0.5,1.7-1.1,2.2l0,0c-0.6,0.5-1.4,0.9-2.3,1.3l0,0c-1.8,0.6-4.1,1-6.4,1l0,0c-1.1,0-3.3-0.1-5.3-0.1l0,0L19.1,50H8.6
				c-3.9,0-6.9-3.2-7-7.1l0,0V7.1c0-3.9,3.1-7.1,7-7.1l0,0h26.5c2,0,3.7,1.1,4.6,2.7l0,0l12,16.6l0,0.1c0.9,1.6,1.4,3.5,1.4,5.5l0,0
				l0,0V25l0,0c0,2-0.5,3.9-1.4,5.5l0,0l0,0.1l-12,16.6c-0.9,1.6-2.7,2.7-4.6,2.7l0,0l-9.8,0C24.7,50,24.2,49.5,24.2,48.9L24.2,48.9
				z"
          />
        </g>
        <g id="XMLID_3204_">
          <path
            id="XMLID_3239_"
            class="st0"
            d="M99.7,12.5h4.6l-5.8,25h-5.2l-4.2-19.2L85,37.5h-5.2l-5.9-25h4.8l4,19.3l4-19.3h5.1
				l4.3,19.3L99.7,12.5z"
          />
          <path
            id="XMLID_3236_"
            class="st0"
            d="M113.7,34.5c2.1,0,3.8-0.9,4.6-2.6h4c-0.9,3-3.6,6-8.4,6c-6,0-9.4-4.6-9.4-9.9
				c0-5.6,3.8-9.5,9.1-9.5c5.7,0,9.2,4.6,8.9,10.9h-13.8C109,32.8,111.4,34.5,113.7,34.5z M118.3,26.4c-0.1-2.9-2.3-4.7-4.7-4.7
				c-1.9,0-4.6,1.1-4.9,4.7H118.3z"
          />
          <path
            id="XMLID_3233_"
            class="st0"
            d="M129.9,21.4c1.1-1.8,3-2.9,5.5-2.9c4.4,0,8.1,3.8,8.1,9.7c0,6-3.7,9.7-8.1,9.7
				c-2.5,0-4.4-1.1-5.5-2.9v2.4h-4.1v-25h4.1V21.4z M139.2,28.2c0-3.9-2-6.3-4.7-6.3c-2.7,0-4.8,2.1-4.8,6.3c0,4.3,2.1,6.4,4.8,6.4
				C137.3,34.6,139.2,32.1,139.2,28.2z"
          />
          <path
            id="XMLID_3230_"
            class="st0"
            d="M150.6,21.4c1.1-1.8,3-2.9,5.5-2.9c4.5,0,8,3.8,8,9.7c0,6-3.4,9.7-8,9.7
				c-2.5,0-4.4-1.1-5.5-2.9v8.5h-4.1V18.9h4.1V21.4z M159.8,28.2c0-3.9-1.7-6.3-4.6-6.3c-2.7,0-4.8,2.1-4.8,6.3
				c0,4.3,2.1,6.4,4.8,6.4C158,34.6,159.8,32.1,159.8,28.2z"
          />
          <path id="XMLID_3227_" class="st0" d="M171.4,16.6h-4.1v-4.1h4.1V16.6z M171.4,37.5h-4.1V18.9h4.1V37.5z" />
          <path id="XMLID_3225_" class="st0" d="M176,37.5v-25h4.1v25H176z" />
          <path
            id="XMLID_3222_"
            class="st0"
            d="M192.5,37.9c-4.5,0-9.1-3-9.1-9.7s4.6-9.7,9.1-9.7s9.1,3,9.1,9.7S197,37.9,192.5,37.9z
				 M197.4,28.2c0-4.3-2.3-6.4-4.9-6.4s-4.9,2.1-4.9,6.4s2.3,6.3,4.9,6.3S197.4,32.5,197.4,28.2z"
          />
          <path
            id="XMLID_3220_"
            class="st0"
            d="M209.6,14v4.9h3.7v3h-3.7V32c0,1.9,0.4,2.3,2.2,2.3h1.5v3.1h-3c-4,0-4.8-1.1-4.8-4.9V21.9
				h-2.8v-3h2.8V14H209.6z"
          />
          <path
            id="XMLID_3205_"
            class="st0"
            d="M223.1,21.7c-1.8,0-3.4,0.8-3.4,2s0.9,1.9,2.5,2.2l2.6,0.5c3.8,0.7,6.6,1.9,6.6,5.5
				c0,3.9-3.7,6-7.9,6c-4.6,0-7.6-2.6-8-6.1h4c0.4,1.9,1.8,3,4.2,3c2.1,0,3.7-0.9,3.7-2.4c0-1.5-1.4-2.2-3.2-2.6l-2.8-0.6
				c-3.1-0.6-5.6-2-5.6-5.4c0-3.3,3.5-5.4,7.5-5.4c3.6,0,6.9,1.8,7.7,5.5h-3.9C226.7,22.3,225.2,21.7,223.1,21.7z"
          />
        </g>
      </g>
      <g id="XMLID_3173_">
        <path id="XMLID_3201_" class="st0" d="M263,12.3V16h-13.5v6.8h12.7v3.7h-12.7v7.4H263v3.7h-17.9V12.3H263z" />
        <path
          id="XMLID_3199_"
          class="st0"
          d="M272.9,21.6c-1.8,0-3.5,0.8-3.5,2.1c0,1.3,0.9,1.9,2.5,2.2l2.7,0.5c3.8,0.7,6.7,1.9,6.7,5.6
			c0,3.9-3.7,6.1-8,6.1c-4.6,0-7.7-2.6-8.1-6.2h4c0.4,1.9,1.8,3,4.2,3c2.2,0,3.8-0.9,3.8-2.4c0-1.5-1.4-2.2-3.2-2.6l-2.8-0.6
			c-3.2-0.6-5.6-2.1-5.6-5.5c0-3.3,3.6-5.4,7.6-5.4c3.7,0,7,1.8,7.8,5.5H277C276.6,22.3,275,21.6,272.9,21.6z"
        />
        <path
          id="XMLID_3196_"
          class="st0"
          d="M288.8,21.4c1.1-1.8,3.1-2.9,5.6-2.9c4.6,0,8.1,3.8,8.1,9.8c0,6-3.5,9.8-8.1,9.8
			c-2.5,0-4.5-1.1-5.6-2.9v8.6h-4.1V18.9h4.1V21.4z M298.1,28.2c0-3.9-1.7-6.4-4.6-6.4c-2.7,0-4.8,2.1-4.8,6.4
			c0,4.3,2.1,6.4,4.8,6.4C296.4,34.7,298.1,32.2,298.1,28.2z"
        />
        <path
          id="XMLID_3193_"
          class="st0"
          d="M317.3,25.9v-0.3c0-3.2-1.8-4.2-3.9-4.2c-2.1,0-3.7,1.1-3.8,3.4h-4.1c0.3-3.8,3.5-6.4,8-6.4
			c4.5,0,8,2.1,7.9,8.1c0,0.9-0.1,3.1-0.1,4.8c0,2.4,0.2,4.8,0.6,6.4h-3.8c-0.1-0.8-0.3-1.3-0.3-2.5c-1.2,2-3.4,3-6.2,3
			c-4.1,0-6.9-2.2-6.9-5.6C304.7,27.8,310.5,26.6,317.3,25.9z M309.1,32.4c0,1.6,1.4,2.6,3.5,2.6c3.1,0,4.9-1.6,4.9-4.7v-1.4
			C311.5,29.4,309.1,30.2,309.1,32.4z"
        />
        <path
          id="XMLID_3177_"
          class="st0"
          d="M335.5,18.4c4.5,0,6.4,2.9,6.4,7.4v11.8h-4.1V26.8c0-2.5-0.4-5-3.6-5s-4.4,2.4-4.4,5.8v10
			h-4.1V18.9h4.1v2.6C330.9,19.5,332.9,18.4,335.5,18.4z M341,12c-0.6,3.6-2.9,4.4-4.5,4.4c-2.2,0-3.1-1.6-4.5-1.6
			c-1,0-1.5,0.5-1.7,1.5h-3c0.6-3.6,2.9-4.4,4.5-4.4c2.2,0,2.9,1.6,4.5,1.6c1,0,1.5-0.5,1.7-1.5H341z"
        />
        <path
          id="XMLID_3174_"
          class="st0"
          d="M357.7,25.9v-0.3c0-3.2-1.8-4.2-3.9-4.2c-2.1,0-3.7,1.1-3.8,3.4h-4.1c0.3-3.8,3.5-6.4,8-6.4
			c4.5,0,8,2.1,7.9,8.1c0,0.9-0.1,3.1-0.1,4.8c0,2.4,0.2,4.8,0.6,6.4h-3.8c-0.1-0.8-0.3-1.3-0.3-2.5c-1.2,2-3.4,3-6.2,3
			c-4.1,0-6.9-2.2-6.9-5.6C345.1,27.8,350.8,26.6,357.7,25.9z M349.5,32.4c0,1.6,1.4,2.6,3.5,2.6c3.1,0,4.9-1.6,4.9-4.7v-1.4
			C351.9,29.4,349.5,30.2,349.5,32.4z"
        />
      </g>
    </g>
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useColors } from 'vuestic-ui'
const { getColor, shiftHSLAColor } = useColors()

const props = withDefaults(
  defineProps<{
    height?: number | string
    color?: string
  }>(),
  {
    height: 16,
    color: 'primary',
  },
)

const colorsComputed = computed(() => {
  const color = getColor(props.color, 'primary')
  return { start: color, end: shiftHSLAColor(color, { l: -20 }) }
})
</script>
